module.exports = __webpack_public_path__ + "BLACKHAWK.ttf";